<div class="maintitle">
  <div>angular-mydatepicker</div>
</div>
<div class="pagecontent">
  <div>
    <h4>ngModel example</h4>
    <div class="normalmode">
      <date-picker-ngmodel>loading...</date-picker-ngmodel>
    </div>
  </div>

  <div class="flexcontainer">
    <div class="flexitem">
        <h4>Reactive forms example</h4>
        <div class="normalmode">
          <date-picker-reactive-forms>loading...</date-picker-reactive-forms>
        </div>
    </div>

    <div class="flexitem">
        <h4>Div host element example</h4>
        <div class="normalmode">
            <date-picker-div-host-element>loading...</date-picker-div-host-element>
        </div>
    </div>

    <div class="flexitem">
        <h4>Inline example</h4>
        <div class="normalmode">
          <date-picker-inline>loading...</date-picker-inline>
        </div>
    </div>

  </div>


  
</div>



